module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_figure-ee078ef19a3b798940e7cf944e49f4dd.gif";